var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('banner-wrapper',{attrs:{"wrapperText":_vm.wrapperText}}),_c('NewsInfo',{attrs:{"newsList":_vm.newsList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }